var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 19.9998L20.2532 15.9998L13.3332 11.9998V19.9998ZM28.7465 9.55984C28.9198 10.1865 29.0398 11.0265 29.1198 12.0932C29.2132 13.1598 29.2532 14.0798 29.2532 14.8798L29.3332 15.9998C29.3332 18.9198 29.1198 21.0665 28.7465 22.4398C28.4132 23.6398 27.6398 24.4132 26.4398 24.7465C25.8132 24.9198 24.6665 25.0398 22.9065 25.1198C21.1732 25.2132 19.5865 25.2532 18.1198 25.2532L15.9998 25.3332C10.4132 25.3332 6.93317 25.1198 5.55984 24.7465C4.35984 24.4132 3.5865 23.6398 3.25317 22.4398C3.07984 21.8132 2.95984 20.9732 2.87984 19.9065C2.7865 18.8398 2.7465 17.9198 2.7465 17.1198L2.6665 15.9998C2.6665 13.0798 2.87984 10.9332 3.25317 9.55984C3.5865 8.35984 4.35984 7.5865 5.55984 7.25317C6.1865 7.07984 7.33317 6.95984 9.09317 6.87984C10.8265 6.7865 12.4132 6.7465 13.8798 6.7465L15.9998 6.6665C21.5865 6.6665 25.0665 6.87984 26.4398 7.25317C27.6398 7.5865 28.4132 8.35984 28.7465 9.55984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9424e37b40b705e2c13cfde25c017a91.svg";
export { ForwardRef as ReactComponent };